import SalesDocumentPrint from './SalesDocumentPrint';

/** Sales Portal > Print A/R Invoices (module sales-invoice-print). */
export default function SalesInvoicePrint() {
  return <SalesDocumentPrint kind="invoice" />;
}
